export { Table as default } from './Table'
export { Details } from './Details'
